import { Action } from '../../../shared/xs/actions';

export class GetEnterpriseCompanyListAction implements Action {
  static readonly type = '[Enterprise] Get portfolio company list';
}
